export const environment = {
    production: true,
    uadSecret: 'KfPjZn7jPu6rtRyMZGzV81+wU4hKnYCr9eKw5Pn5H6Y=',
    azureMapsKey: 'bVLE-0X6_4fJ5AR_1knIm5FQ5aG6oRtollKfqBLyhkk',
    mockAPIProductConfig: "https://apim.development.swiftant.com/",
    baseAPIUrl: 'https://dev-afrisure-uad-api.insure.digital/',
    authAPIURL: 'https://dev-common-uad-api.insure.digital/',
    productConfigBaseUrl : 'https://demo-prodconfig-api-primez.insure.digital/',
    coreBaseUrl: 'https://uaedemo-core-api-primez.insure.digital/',
    googleMapKey: 'AIzaSyAxdzR3_Eqg5DSNslA6FvsBvXbwhx8VG7g'// 'AIzaSyDywmyAriryGz7BKtW6igwAdOMALDYKZLk'
  };
  